var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"page-home"},[_vm._m(0),_c('section',[_c('ViewExample')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',[_c('h1',[_vm._v("Hello World")])])
}]

export { render, staticRenderFns }